module.exports = __webpack_public_path__ + "img/description.aec52315.svg";